module.exports = __webpack_public_path__ + "static/media/icon_something_went_wrong.66ceb16e.svg";